import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight, Play, Shield, Zap, Users } from 'lucide-react'
import FadeInOnScroll from './FadeInOnScroll'
import imageUrl from '../assets/cat.png'

const Hero = () => {
  const stats = [
    { icon: Shield, value: '99.9%', label: 'Uptime' },
    { icon: Users, value: '1,000+', label: 'Trusted Patients' },
    { icon: Zap, value: '24/7', label: 'Support' },
  ]

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 gradient-bg opacity-10"></div>
      
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%230ea5e9%22%20fill-opacity%3D%220.05%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]"></div>

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <FadeInOnScroll
            direction="left"
            duration={0.8}
            distance={100}
            className="text-center lg:text-left"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="inline-flex items-center px-4 py-2 bg-primary-50 text-primary-700 rounded-full text-sm font-medium mb-6"
            >
              <span className="w-2 h-2 bg-primary-500 rounded-full mr-2"></span>
              Leading Ultrasound Technology
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight"
            >
              Advanced{' '}
              <span className="text-gradient">Medical Imaging</span>
              {' '}Solutions
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0"
            >
              Cutting-edge ultrasound and radiology technology that empowers healthcare professionals 
              with precise diagnostic capabilities and improved patient outcomes.
            </motion.p>



            {/* Stats */}
            <FadeInOnScroll
              direction="up"
              duration={0.8}
              delay={1}
              className="grid grid-cols-3 gap-6 mt-12 max-w-md mx-auto lg:mx-0"
            >
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg mx-auto mb-3">
                    <stat.icon className="w-6 h-6 text-primary-500" />
                  </div>
                  <div className="text-2xl font-bold text-gray-900">{stat.value}</div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </FadeInOnScroll>
          </FadeInOnScroll>

          {/* Right content - Hero image */}
          <FadeInOnScroll
            direction="right"
            duration={0.8}
            delay={0.4}
            distance={100}
            className="relative"
          >
            <div className="relative">
              {/* Main image */}
              <div className="bg-gradient-to-br from-primary-500 to-accent-400 rounded-2xl p-4 text-white text-center">
                <img 
                  src={imageUrl} 
                  alt="Ultrasound Imaging Technology" 
                  className="w-full h-auto rounded-xl"
                  style={{ maxHeight: '500px', objectFit: 'contain' }}
                />
              </div>


            </div>
          </FadeInOnScroll>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center"
        >
          <div className="w-1 h-3 bg-gray-400 rounded-full mt-2"></div>
        </motion.div>
      </motion.div>
    </section>
  )
}

export default Hero 